import {
    Card, CardContent, CardHeader, Grid, CardMedia,
    TextField, Button, Collapse, Alert, Box, IconButton
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function AlumnoNuevoIngreso() {
    const [usuario, setUsuario] = useState({
        id: '',
        emailInstitucional: ''
    })
    const [helperMatricula, setHelperMatricula] = useState('')
    const [errorMatricula, setErrorMatricula] = useState(false)

    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [severity, setSeverity] = useState('error')

    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (usuario.id < 2112042389 || String(usuario.id).length !== 10) {
            console.log(`*${usuario.id}* ${String(usuario.id).length}`)
            setLoading(false)
            setHelperMatricula('Esto no parece ser una matrícula válida')
            setErrorMatricula(true)
            return
        }
        else {
            const resUsuario = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/alumno/${usuario.id}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            })
            if (resUsuario.status===200) {
                setLoading(false)
                setHelperMatricula('Ingresaste la matrícula de un usuario registrado, si deseas restablecer tu contraseña debes seleccionar "Restablecer password" en el formulario de Inicio de sesión \nLa opción "Soy alumno de nuevo ingreso" es únicamente para alumnado que no está registrado en el sistema')
                setErrorMatricula(true)
                return
            }            
        }

        const servidor = window.location.host
        setLoading(true)
        //console.log(`usuario: ${JSON.stringify(usuario)}`)

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/auth/nuevoIngreso`, {
            method: "POST",
            body: JSON.stringify(usuario),
            headers: { "Content-Type": "application/json", "servidor": servidor },
        })
        const data = await res.json()
        if(res.status===200||res.status===204)
            setSeverity('success')
        else
            setSeverity('error')

        if (data.message) {
            setOpen(true)
            setMensaje(`${data.message}`)
            setLoading(false)
            sessionStorage.clear()//setItem('token', null)
            return
        }
        else {
            setOpen(true)
            setMensaje('Se ha enviado un mensaje a la dirección de correo que proporcionaste')
        }

        setLoading(false)

        navigate('/')
    }

    const handleChange = e => {
        const nombre = e.target.name
        const valor = e.target.value
        if (nombre === 'id') {
            setErrorMatricula(false)
            setHelperMatricula('')
        }
        setUsuario({ ...usuario, [nombre]: valor })
    }
    return (
        <Grid container direction='row' justifyContent='center' style={{ marginTop: 50 }}>
            <Grid item xs={12} sm={7}>
                <Card>
                    <CardMedia
                        component="img"
                        image="/images/nadu.png"
                        alt="Nadu"
                        style={{ objectFit: 'contain' }}
                    />
                </Card>
            </Grid>

            <Grid item xs={12} sm={5}>
                <Card>
                    <CardHeader title='Registro de alumno de nuevo ingreso'></CardHeader>
                    <CardContent>
                        <form onSubmit={handleSubmit}>
                            <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                                <Grid item xs={12} sm={12}>
                                    <TextField label='Escribe tu matrícula' name='id' onChange={handleChange} value={usuario.id} sx={{ width: '100%' }} helperText={helperMatricula} error={errorMatricula} />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <TextField label='Escribe tu correo electrónico' placeholder='A este correo te llegará un enlace para establecer tu contraseña en el sistema NADU 2, una vez que tu cuenta sea permanente ese correo será sustituído por tu correo institucional' name='emailInstitucional' type="email" multiline onChange={handleChange} value={usuario.emailInstitucional} sx={{ width: '100%' }} />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Button variant='contained' color='primary' type='submit' style={{ marginTop: 43 }} disabled={!usuario.id || !usuario.emailInstitucional || loading}>
                                        Enviar
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                        <Box sx={{ width: '100%' }}>
                            <Collapse in={open}>
                                <Alert severity={severity}
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setOpen(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                    style={{ marginTop: 30 }}
                                >
                                    {mensaje}
                                </Alert>
                            </Collapse>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>

    )
}